export default __webpack_public_path__ + "static/media/error.633bd7bb.png";